<template>
<tr v-if='item' class='item'>
	<td class='points'>{{item.score}}</td>

	<td>
		<p class='title'>
			<a v-if='item.url' v-bind:href='item.url' target='_blank' rel='noopener noreferrer'>{{item.title}}</a>
			<router-link v-else v-bind:to='itemUrl'>{{item.title}}</router-link>
		</p>
		<p class='subtitle'>
			by {{item.by}} | {{timeFromNow}} | <router-link v-bind:to='itemUrl'>{{commentsCount}}</router-link>
		</p>
	</td>
</tr>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import timeFromNow from '../lib/timeFromNow'
import commentCount from '../lib/commentCount'

export default {
	name: "ListItem",
	props: ['id'],
	data: () => ({ item: {} }),
	created: function() {
		this.GET_ITEM(this.id).then(() => {this.item = this.getItemById(this.id)})
	},
	computed: {
		...mapGetters([
			'getItemById'
		]),
		timeFromNow() {
			return timeFromNow(this.item.time)
		},
		commentsCount() {
			return commentCount(this.item.descendants)
		},
		itemUrl() {
			return`/item/${this.item.id}`
		}
	},
	methods: {
		...mapActions(['GET_ITEM'])
	}
}
</script>

<style lang='stylus'>
TD
	text-align: left
	vertical-align: baseline
	padding: 1em 0.4em
	border-bottom: 1px solid #ccc

TR
	border-radius: 4px
	background: #FAFAFA

	&:first-child TD
		border-top: 1px solid #f2f3f5


.points
	font-weight: 600
	color: #f60
	text-align: center

.title, .subtitle
	margin: 0
	padding: 0

.title
	font-weight: 600
	font-size: 16px

.subtitle
	color: #999
	font-size: 14px

</style>
